/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class UserOfferSourceCategoryEnum.
* @enum {}
* @readonly
*/
export default class UserOfferSourceCategoryEnum {
    
        /**
         * value: "direct_before_search"
         * @const
         */
        "direct_before_search" = "direct_before_search";

    
        /**
         * value: "direct_after_search"
         * @const
         */
        "direct_after_search" = "direct_after_search";

    
        /**
         * value: "agent_detail"
         * @const
         */
        "agent_detail" = "agent_detail";

    

    /**
    * Returns a <code>UserOfferSourceCategoryEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/UserOfferSourceCategoryEnum} The enum <code>UserOfferSourceCategoryEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

